export const ENDPOINT_APP_URL_CHECKOUT = process.env.REACT_APP_CHECKOUT;
export const REACT_APP_COOKIE_INSTANA = '#9vsy991^5ppnm-c6u4fg)*@ap12w#-xgk)a(w11_bzkvgt!98';

export const MESSAGE_CANCEL_REQUEST = 'Request cancel message by USER';
